module.exports = __webpack_public_path__ + "static/img/1807_phase_function_Paper_PointsHejduk_Prediction.3356fdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1807_phase_function_Paper_PointsHejduk_Prediction.png
// module id = HtcL
// module chunks = 0